import {
  ORDER_API_STATUS,
  ORDER_UI_STATUS,
  ORDER_STATUS_TO_UI_MAPPING,
} from "./orders.constants";

export const getOrderStatus = order => {
  const { orderStatus } = order;

  if (isPartialExecutedOrder(order))
    return ORDER_UI_STATUS.PARTIAL_SUCCESSFULL;

  if (ORDER_STATUS_TO_UI_MAPPING[orderStatus]) {
    return ORDER_STATUS_TO_UI_MAPPING[orderStatus];
  }
  if (isFillingOrder(order)) {
    return ORDER_UI_STATUS.FILLING;
  }

  return ORDER_UI_STATUS.PLACED;
};

export const isPartialExecutedOrder = order => {
  return (
    order.orderStatus === ORDER_API_STATUS.CANCELLED &&
    order.filledQuantity > 0
  );
};

export const isFillingOrder = order => {
  return (
    order.filledQuantity > 0 &&
    order.filledQuantity < order.quantity
  );
};
